export default {"src":"/_next/static/media/help.de231efe.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};